import React from 'react';
import {EventComponent} from './Event.Component';
import { connect } from "react-redux";
import {EventAddContainer} from './EventAdd.Container';
import { httpServices } from '../../../services/httpServices';
import { history } from './../../../helpers/history';
import { getRelativeUrl } from '../../common/common';
import MixpanelManager from  '../../../services/Analytics';
import { ErrorPage } from '../../common/error';
import { CustomProgressBar } from '../../common/CustomProgressBar';
import { setSelectedTabIndex } from '../../../redux/store/reducers/tabs';
import { setSavedFilters, updateSavedFilterAction } from '../../../redux/store/reducers/savedFilters';

const BASE_PATH = process.env.REACT_APP_BASE_PATH;
const filterFields = {
    'my': {
        'start_date' : null,
        'end_date' : null,
        'requestStatus' : 0,
        'project' : 0,
        'emp_status' : 0,
        'user_id' : 0,
        'task' : 0
    } ,
    'review': {
        'start_date' : null,
        'end_date' : null,
        'requestStatus' : -1,
        'project' : 0,
        'emp_status' : 0,
        'user_id' : 0,
        'task' : 0
    } ,
    'all': {
        'start_date' : null,
        'end_date' : null,
        'requestStatus' : 0,
        'project' : 0,
        'emp_status' : 0,
        'user_id' : 0,
         'task' : 0
    },
}

class EventContainer extends React.Component{
    constructor(props){
        super(props);
        this.state ={
            openAdd : false,
            editPermission : false,
            filterViewState : false,
            formFields : filterFields,
            requests : [],
            all_requests : [],
            review_requests : [],
            requestStatus :[],
            employeeStatus : [],
            Employee : [],
            filterTOTasks : [],
            myView : false,
            reviewView : false,
            allView : false,
            editView : false,
            showLoader: true,
            hasPermission: true,
            periodStartDate: new Date (),
            periodEndDate: new Date (),
            reviewCount: '',
            errors: {},
        }
        this.createEvent = this.createEvent.bind(this);
        this.onClose = this.onClose.bind(this);
        this.getEventList = this.getEventList.bind(this);
        this.viewEvent = this.viewEvent.bind(this);
        this.filterView = this.filterView.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.onTabChange = this.onTabChange.bind(this);
        this.MixpanelManager = new MixpanelManager();
        this.resetFilter = this.resetFilter.bind(this);
        this.filterSubmit = this.filterSubmit.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onParentUpdate = this.onParentUpdate.bind(this);
        this.getEventPermissions = this.getEventPermissions.bind(this);
        this.viewStaffDetails = this.viewStaffDetails.bind(this);
    }

    componentDidMount = () => {
        var fromDashboard = (this.props.location.state && this.props.location.state.fromDashboard) ? this.props.location.state.fromDashboard : false;
        if (fromDashboard) {
             var dashboardFilter = (this.props.location.state && this.props.location.state.dashboardFilter) ? this.props.location.state.dashboardFilter : [];
            let startDate = (dashboardFilter.eventRequestStartDate && dashboardFilter.eventRequestStartDate != '') ? dashboardFilter.eventRequestStartDate : null;
            let endDate = (dashboardFilter.eventRequestEndDate && dashboardFilter.eventRequestEndDate != '') ? dashboardFilter.eventRequestEndDate : null;
            let formFields = this.state.formFields;
            formFields['review']['start_date'] = startDate;
            formFields['review']['end_date'] = endDate;
            formFields['requestStatus'] = -1;
            formFields['project'] = 0;
            formFields['emp_status'] = 0;
            formFields['user_id'] = 0;
            formFields['task'] = 0;
            this.setState({
                formFields: formFields
            });
        }
        this.getEventPermissions();
    }
    componentDidUpdate = (prevProps) => {
        // Fetching event details based on the redux store values after store values are set initially
        if (prevProps.savedFilterValues.length > 0 && this.state.counter === 0) {
            this.getEventList(this.state.eventTabSelected);
            this.setState({
                counter: 1
            });
        }
    }    
    onTabChange = (tab = '') => {
        this.getEventList(tab);
        this.setState({
            eventTabSelected: tab,
            errors: {},
            saveFilter: false,
        });
        let mixPanelAction = '';
        switch(tab) {
            case 'my':
                mixPanelAction = 'my-requests-tab-clicked';
                break;
            case 'review':
                mixPanelAction = 'review-requests-tab-clicked';
                break;
            case 'all':
                mixPanelAction = 'all-requests-tab-clicked';
                break;
            default:
                mixPanelAction = '';
        }
        this.MixpanelManager.trackEvent('Request', { module: 'Request', feature: 'event', action: mixPanelAction });
        const obj = { page: "event", selected: tab };
        this.props.setTabIndexValue(obj);
    };
    createEvent = (id = 0) => {
        let editId = 0;
        if (id) {
            editId = id;
        }
        this.setState({
            openAdd : true,
            editId : editId,
            showLoader: true,
        });
    }
    
    onSuccess = () => {
        this.setState({
            showLoader: false,
        });    
    }
        
    onParentUpdate = () => {
        this.getEventList(this.state.eventTabSelected);
    }
    
    onClose = () =>{
          this.setState({
            openAdd : false,
            showLoader: false,
        });
    }
    handleValidation() {
        let formIsValid = true;
        let errors = {};
        const { start_date, end_date } = this.state.formFields;
        if (start_date && end_date && start_date > end_date) {
            errors["endDate"] = "End date should be greater than start date";
            formIsValid = false;
        }
        this.setState({errors : errors});
        return formIsValid;
    }
    filterSubmit = () => {
        if (this.handleValidation()) {
            this.setState({
                filterViewState: false,
            }, function () {
                this.getEventList(this.state.eventTabSelected);
            });
        }
    }
    resetFilter = (tab) => {
        let ff = this.state.formFields; 
        ff['start_date'] = null;
        ff['end_date'] = null;
        ff['requestStatus'] = tab === 'review' ? -1:0;
        ff['project'] = '0';
        ff['emp_status'] = '0';
        ff['user_id'] = '0';
        ff['project_id'] = 0;
        ff['task'] = 0;
        this.setState({
            formFields: ff,
            right: false,
            saveFilter : false,
        },()=>{
            this.filterSubmit(tab);}
        );
    }
    getEventPermissions = () => {
        let apiEndpoint = 'api/request/event/list-permissions';
        return httpServices.post(apiEndpoint)
            .then(response => {
                if (response.data && response.data.permission) {
                    const apiTab = response.data.tab;
                    const reduxTab = this.props.selectedEventTab;
                    const firstLoadTab = (reduxTab === 'my') ? apiTab : reduxTab;
                    this.setState({
                        showLoader : false,
                        editPermission: response.data.permission,
                        myView: response.data.myView,
                        reviewView: response.data.reviewView,
                        allView: response.data.allView,
                        editView: response.data.editView,
                        eventTabSelected: firstLoadTab
                    }, function () {
                        this.getEventList(this.state.eventTabSelected);
                    });
                    if (reduxTab === 'my') {
                        this.props.setTabIndexValue({ page: "event", selected: firstLoadTab });
                    }
                }
                else{
                    this.setState({
                        showLoader : false,
                        dataLoaded : true,
                        hasPermission : false,
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    getUsers = () => {
        let tab = this.state.eventTabSelected;
        let filter = this.state.formFields;
        let apiEndpoint = 'api/location/list-users';
        return httpServices.post(apiEndpoint, { emp_status: filter.emp_status, tab: tab, start_date: filter.start_date, end_date: filter.end_date })
            .then(response => {
                if (response.data) {
                    this.setState({
                        Employee: response.data,
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    
    getEventList = (tab = '') => {
        let apiEndpoint = 'api/request/event/list';
        let filter = filterFields[tab];
        let savedFilterValues = this.props.savedFilterValues;
        let relativeUrl = getRelativeUrl();
        if (relativeUrl !== '') {
            relativeUrl = relativeUrl + '#' + tab;
            let indexValue = savedFilterValues.findIndex((element) => element.relative_url === relativeUrl);
            if (indexValue !== -1) {
                let savedFilter = savedFilterValues[indexValue]['filter_options'];
                filter = Object.assign(filter, savedFilter);
            }
        }
        let data = {
            'tab': tab,
            'start_date': filter.start_date,
            'end_date': filter.end_date,
            'emp_status': filter.emp_status,
            'status': filter.requestStatus,
            'task': filter.task,
            'user_id': filter.user_id
        }
        this.setState({ showLoader: true });
        return httpServices.post(apiEndpoint, data)
            .then(response => {
                if (response.data && response.data.permission) {
                    let requests = response.data.events;
                let filterTOTasks = response.data.timeoff_tasks ? response.data.timeoff_tasks : [];
                this.setState({
                    showLoader : false,
                    editPermission: response.data.permission,
                    requestStatus: response.data.requestStatus,                    
                    reviewCount: response.data.reviewCount,
                    employeeStatus : response.data.emp_status,
                    editView: response.data.editView,
                    filterTOTasks : filterTOTasks,
                });
                let filterFields = filter;
                    if (response.data.payperiod_start_date && !filterFields.start_date) {
                        filterFields.start_date = response.data.payperiod_start_date;
                        filterFields.end_date = response.data.payperiod_end_date;
                    }
                let startDateArr = filterFields.start_date.split('-');
                let startDateObj = new Date(startDateArr[0], startDateArr[1] - 1, startDateArr[2]);
                let endDateArr = filterFields.end_date.split('-');
                let endDateObj = new Date(endDateArr[0], endDateArr[1] - 1, endDateArr[2]);
                if (response.data.tab === "all") {
                    this.setState({
                        all_requests: requests,
                        formFields: filterFields,
                        periodStartDate: startDateObj,
                        periodEndDate: endDateObj,
                    }, () => this.getUsers());

                }
                else if (response.data.tab === "review") {
                    this.setState({
                        review_requests: requests,
                        formFields: filterFields,
                        periodStartDate: startDateObj,
                        periodEndDate: endDateObj,
                    }, () => this.getUsers());

                }
                else {
                    this.setState({
                        requests: requests,
                        formFields: filterFields,
                        periodStartDate: startDateObj,
                        periodEndDate: endDateObj,
                    });
                }
                }
                else
                {
                    this.setState({
                        showLoader : false,
                        dataLoaded : true,
                        hasPermission : false,
                    });
                }
                
            })
    }
    
    viewEvent = (id) => {
        if(id) {
            history.push('event/view/' + id);
        }
    }
    viewStaffDetails = (userId) => {
        if(userId) {
            window.open(BASE_PATH+'/staff/view/' + userId , '_blank');
        }
    }
    filterView = (open) => () => {
        this.setState({filterViewState : open});
    };
    handleStartDateChange = (date) => {
        const f = this.state.formFields;
        const field = 'start_date';
        f[field] = date;
        this.setState({
            formFields: f
        },()=>{
            let tab = this.state.eventTabSelected;
            if(tab === "all" || tab === "review") {
                this.getUsers();
            }
        })
    };
    handleEndDateChange = (date) => {
        const f = this.state.formFields;
        const field = 'end_date';
        f[field] = date;
        this.setState({
            formFields: f
        },()=>{
            let tab = this.state.eventTabSelected;
            if(tab === "all" || tab === "review") {
                this.getUsers();
            }
        });
    };
    handleOnChange = (evt, value) => {
        const f = this.state.formFields;
        const name = evt.target.name;
        if (name === 'saveFilter') {
            this.setState({
                saveFilter: value
            });
        }
        else {
            f[name] = evt.target.value;
            this.setState({
                formFields: f
            }, () => {
                if (name === "emp_status") {
                    this.getUsers();
                }
            });
        }
    }

      render() {
        return (
            <>
           <CustomProgressBar loaderOpen={this.state.showLoader}/>
           {(this.state.hasPermission) ?
            <EventComponent 
                CreateEvent = { this.createEvent }
                EditPermission = { this.state.editPermission }
                ViewEvent = { this.viewEvent}
                FilterView = {this.filterView}
                FilterViewState = {this.state.filterViewState}
                FormFields =  {this.state.formFields}
                handleStartDateChange={this.handleStartDateChange}
                handleEndDateChange={this.handleEndDateChange}
                PeriodStartDate = {this.state.periodStartDate}
                PeriodEndDate = {this.state.periodEndDate}
                RequestStatus = {this.state.requestStatus}
                HandleOnChange = {this.handleOnChange}
                MyView = {this.state.myView}
                ReviewView = {this.state.reviewView}
                AllView = {this.state.allView}
                EditView = {this.state.editView}
                Requests = {this.state.requests}
                AllRequests = {this.state.all_requests}
                ReviewRequests = {this.state.review_requests}
                Employee = {this.state.Employee}
                onTabChange = {this.onTabChange }
                Tab = {this.state.eventTabSelected}
                EmployeeStatus = {this.state.employeeStatus}
                FilterTOTasks = {this.state.filterTOTasks}
                ResetFilter = {this.resetFilter}
                FilterSubmit = {this.filterSubmit}
                OnSuccess ={ this.onSuccess }
                ReviewCount = {this.state.reviewCount}
                ViewStaffDetails = {this.viewStaffDetails}
                FormFields = {this.state.formFields}
                Errors = {this.state.errors}
            />
            :<ErrorPage />}
             <EventAddContainer
                OpenAdd = { this.state.openAdd }
                OnClose = { this.onClose }
                OnSuccess ={ this.onSuccess }
                EditId = { this.state.editId }
                OnParentUpdate = { this.onParentUpdate }
                Title={ this.state.editId ? "EDIT" : ''}
            />
            </>
        )
    }
}
const mapStateToProps = (state) => {
    const savedFilterValues =  state.savedFilters.savedFilterValues ? state.savedFilters.savedFilterValues : {};
    const selectedEventTab = state.Tabs.allTabs['event'] ? state.Tabs.allTabs['event'] : 'my';
    return {
        savedFilterValues: savedFilterValues,
        selectedEventTab: selectedEventTab
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setSavedFilterVal: () => dispatch(setSavedFilters()),
        setTabIndexValue: (obj) => dispatch(setSelectedTabIndex(obj)),
        updateSavedFilterVal: ({obj}) => dispatch(updateSavedFilterAction({obj}))
    }
}
const connectedEventContainer = connect(mapStateToProps, mapDispatchToProps)(EventContainer);
export {connectedEventContainer as EventContainer};        
